export default __webpack_public_path__ + "static/media/console_light.83340d95.png";